import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Projects = () => {
  const projects = [
    {
      title: 'Project 1',
      description: 'Description of project 1',
      tech: ['React', 'Node.js', 'MongoDB'],
      github: 'https://github.com',
      live: 'https://example.com'
    },
    // Add more projects here
  ];

  return (
    <ProjectsSection>
      <Title>{'<Projects />'}</Title>
      <ProjectsGrid>
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <ProjectHeader>
              <FolderIcon>📁</FolderIcon>
              <Links>
                <a href={project.github} target="_blank" rel="noopener noreferrer">GitHub</a>
                <a href={project.live} target="_blank" rel="noopener noreferrer">Live</a>
              </Links>
            </ProjectHeader>
            <ProjectTitle>{project.title}</ProjectTitle>
            <ProjectDescription>{project.description}</ProjectDescription>
            <TechList>
              {project.tech.map((tech, i) => (
                <TechItem key={i}>{tech}</TechItem>
              ))}
            </TechList>
          </ProjectCard>
        ))}
      </ProjectsGrid>
    </ProjectsSection>
  );
};

const ProjectsSection = styled.section`
  min-height: 100vh;
  padding: 100px 10% 0;
`;

const Title = styled.h2`
  color: #64ffda;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const ProjectCard = styled(motion.div)`
  background: #112240;
  padding: 2rem;
  border-radius: 4px;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ProjectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const FolderIcon = styled.div`
  font-size: 2rem;
`;

const Links = styled.div`
  display: flex;
  gap: 1rem;

  a {
    color: #ccd6f6;
    text-decoration: none;
    &:hover {
      color: #64ffda;
    }
  }
`;

const ProjectTitle = styled.h3`
  color: #ccd6f6;
  margin-bottom: 1rem;
`;

const ProjectDescription = styled.p`
  color: #8892b0;
  margin-bottom: 1rem;
`;

const TechList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
`;

const TechItem = styled.li`
  color: #64ffda;
  font-size: 0.9rem;
`;

export default Projects;